import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarCartService } from 'src/app/services/sidebar-cart.service';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { ShoppingCartComponent } from '../shopping-cart/shopping-cart.component';

@Component({
  selector: 'app-shopping-cart-sidebar',
  standalone: true,
  imports: [CommonModule, SidebarModule, ButtonModule, ShoppingCartComponent],
  templateUrl: './shopping-cart-sidebar.component.html',
  styleUrls: ['./shopping-cart-sidebar.component.scss']
})
export class ShoppingCartSidebarComponent implements OnInit {
  showCartSidebar: boolean = false;

  constructor(
    private sidebarService: SidebarCartService,
    private cdr: ChangeDetectorRef // ✅ Garante atualização da UI
  ) {}

  ngOnInit(): void {
    this.sidebarService.sidebarVisibility$.subscribe((isVisible) => {
      console.log("📢 SidebarCartService mudou para:", isVisible);
      this.showCartSidebar = isVisible;
      this.cdr.detectChanges(); // 🔥 Atualiza a UI quando a sidebar muda
    });
  }

  onCloseCart(): void {
    console.log("📢 Fechando Sidebar via botão");
    this.sidebarService.closeSidebar();
  }
}
